import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery } from '../../../services/process/BRS1/brsService7';

import { CreateData,generateschema} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import Select from "react-select";


const ionIconsList = [
  "home-outline", "briefcase-outline", "business-outline", "bar-chart-outline",
  "document-text-outline", "person-outline", "settings-outline",
  "people-outline", "school-outline", "cash-outline",
  "globe-outline", "build-outline", "cloud-outline", "file-tray-full-outline",
  "heart-outline", "star-outline", "cart-outline", "chatbubble-outline",
  "lock-closed-outline", "key-outline", "mail-outline", "phone-portrait-outline",
  "camera-outline", "calendar-outline", "megaphone-outline", "flag-outline",
  "folder-outline", "medkit-outline", "musical-notes-outline", "newspaper-outline",
  "paper-plane-outline", "send-outline", "location-outline", "cloud-download-outline"
];

const identifier2 = [
    { value: "string", label: "string" },
    { value: "int", label: "int" },
    { value: "special charectors", label: "special charectors" },
    { value: "contains", label: "contains" },
    { value: "starts with", label: "starts with" },
    { value: "ends with", label: "ends with" },

];


function DepartmentCreation() {
  const [formData, setFormData] = useState({division_id: null,groups_id: null,tenants_id:null,entity_id:null,kpis_json:[],jobs_json:[],process:null,pages_json:[]});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [pageinfo, setPageinfo] = useState([]);
  const [processinfo, setProcessinfo] = useState([]);
  const [kpiinfo, setKpiinfo] = useState([]);
  const [jobinfo, setJobinfo] = useState([]);
  const [tenantinfo, setTenantinfo] = useState([]);
  const [groupinfo, setGroupinfo] = useState([]);
  const [entityinfo, setEntityinfo] = useState([]);
  const [divisioninfo, setDivisioninfo] = useState([]);
  const [departmentinfo, setDepartmentinfo] = useState([]);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  useEffect(() => {
    fetchFieldInfo1();
    fetchFieldInfo2();
    fetchOptionsInfo(`SELECT * FROM process_data.job WHERE is_active=1;`,'job_name','primary_id',setJobinfo);
    fetchOptionsInfo(`SELECT * FROM process_data.kpi WHERE is_active=1;`,'kpi_name','primary_id',setKpiinfo);
    fetchOptionsInfo(`SELECT * FROM user_management.tenants WHERE is_active=1;`,'name','tenants_id',setTenantinfo);
    fetchOptionsInfo(`SELECT * FROM process_data.process WHERE is_active=1;`,'process_name','primary_id',setProcessinfo);
  }, []);

  useEffect(() => {
    fetchOptionsInfo(`SELECT * FROM user_management.groups WHERE is_active=1 and tenants_id = ${formData.tenants_id};`,'name','groups_id',setGroupinfo);
  }, [formData.tenants_id]);
  
  useEffect(() => {
    fetchOptionsInfo(`SELECT * FROM user_management.entities WHERE is_active=1 and groups_id = ${formData.groups_id};`,'name','entity_id',setEntityinfo);
  }, [formData.groups_id]);

  useEffect(() => {
    fetchOptionsInfo(`SELECT * FROM user_management.divisions WHERE is_active=1 and entity_id = ${formData.entity_id};`,'name','division_id',setDivisioninfo);
  }, [formData.entity_id]);

  useEffect(() => {
    fetchOptionsInfo(`SELECT * FROM user_management.department WHERE is_active=1 and division_id = ${formData.division_id};`,'name','department_id',setDepartmentinfo);
  }, [formData.division_id]);


  useEffect(() => {
    fetchOptionsInfo(` SELECT pg.primary_id, pg.name  FROM user_management.pages pg  
WHERE FIND_IN_SET( pg.primary_id, REPLACE(REPLACE(REPLACE((SELECT pages FROM process_data.process where primary_id = ${formData.process}), '[', ''), ']', ''), ' ', '') );`,'name','primary_id',setPageinfo);
  }, [formData.process]);




  const [selectedIcon, setSelectedIcon] = useState(null);
  const [search, setSearch] = useState("");

  const filteredIcons = ionIconsList.filter(icon =>
    icon.toLowerCase().includes(search.toLowerCase())
  );
  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 51,"filterconditions":filterconditions  };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          filter: true,
        sortable: true,
          resizable: true,

        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 80, // Set width for the edit column
        });

        columns.push({
          headerName: "Delete",
          field: "delete",
          cellRendererFramework: (params) => (
            <Icon
              name="trash"
              style={{ cursor: 'pointer', color: "red" }}
              onClick={() => handleDeleteclick(params.data)}
            />
          ),
          width: 150, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
        console.log("fields fetched",columns)
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const handleDeleteclick = (row) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this item?");
  
  if (!isConfirmed) {
    return; // Stop execution if user clicks "No"
  }
    
    console.log('formData',row,row.primary_id)
    const updatedFormData = row;

    // Remove primary_id from the copied formData
    // delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'user_management',
      table: 'user_roles',
      set_column : {is_active : 0},
      'where' : [{"user_role_id":row.user_role_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };


const handleEditClick = (row) => {
    console.log("Editing row:", row);

    const updatedRowData = {
        ...row,
        kpis_json: row["kpis"] ? JSON.parse(row["kpis"]) : [],
        pages_json: row["pages"] ? JSON.parse(row["pages"]) : [],
        jobs_json: row["jobs"] ? JSON.parse(row["jobs"]) : []
    };
    setFormData(updatedRowData); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
};

  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT * FROM user_management.user_roles where is_active=1;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };


const fetchOptionsInfo = async (query1,label1,value1,setinfo) => {
  const payload = { query: query1 };

  try {
    const FileUploadCredentials = Fetchexecutequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    const data = response.data;
    const formattedData = data.map(item => ({
      label: item[label1],
      value: item[value1]
    }));

    setinfo(formattedData);
    console.log("Formatted data fetched:", formattedData);
    
  } catch (error) {
    console.error("Error fetching page data:", error);
    setError("Error fetching page data");
  }
};


  const handleCreate = () => {

      const formattedDate = getFormattedDate();
      const updatedFormData = {
        ...formData,
      };


    const payload = {
      database: 'user_management',
      table: 'user_roles',
      formData: updatedFormData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {
    
    console.log('formData',formData,formData.id)
    const updatedFormData = { ...formData };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'user_management',
      table: 'user_roles',
      set_column : updatedFormData,
      'where' : [{"user_role_id":formData.user_role_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleInputChange1 = (selectedOptions, name, isMulti = false) => {
  setFormData((prevData) => ({
    ...prevData,
    [name]: isMulti
      ? selectedOptions.map(option => option.value) // Store as an array for multi-select
      : selectedOptions.value, // Store single value for non-multi-select
  }));
};

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        user_roles
      </h2>

      {error && <div style={{ color: "red" }}>{error}</div>}

      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange}/>
<div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // 3 columns per row
    gap: "20px", // Space between form groups
    margin: "20px",
    backgroundColor: "white", // White background for the entire form
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  }}
>
  {/* First Row */}
  <div>
    <label>Tenant</label>
    <Select
      name="Tenant"
      value={tenantinfo.find(option => option.value === formData.tenants_id)}
      options={tenantinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'tenants_id')}
    />
  </div>

  <div>
    <label>Group</label>
    <Select
      name="Group"
      value={groupinfo.find(option => option.value === formData.groups_id)}
      options={groupinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'groups_id')}
    />
  </div>

  {/* Full Width for Entity */}
  <div>  
    <label>Entity</label>
    <Select
      name="Entity"
      value={entityinfo.find(option => option.value === formData.entity_id)}
      options={entityinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'entity_id')}
    />
  </div>

  <div>  
    <label>Division</label>
    <Select
      name="Division"
      value={divisioninfo.find(option => option.value === formData.division_id)}
      options={divisioninfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'division_id')}
    />
  </div>

  <div>  
    <label>Department</label>
    <Select
      name="Department"
      value={departmentinfo.find(option => option.value === formData.department_id)}
      options={departmentinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'department_id')}
    />
  </div>


  <div>
    <label>Process</label>
    <Select
      name="process"
      value={processinfo.find(option => option.value === formData.process)}
      options={processinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'process')}
    />
  </div>


  <div>
    <label>Pages</label>
    <Select
      name="Pages"
      value={pageinfo.filter(option => formData.pages_json?.includes(option.value))}
      options={pageinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'pages_json', true)}
      isMulti
      closeMenuOnSelect={false}
    />
  </div>


  <div>
    <label>Jobs</label>
    <Select
      name="Jobs"
      value={jobinfo.filter(option => formData.jobs_json?.includes(option.value))}
      options={jobinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'jobs_json', true)}
      isMulti
      closeMenuOnSelect={false}
    />
  </div>

  {/* Second Row */}
  <div>
    <label>KPI</label>
    <Select
      name="KPI"
      value={kpiinfo.filter(option => formData.kpis_json?.includes(option.value))}
      options={kpiinfo}
      onChange={(selectedOptions) => handleInputChange1(selectedOptions, 'kpis_json', true)}
      isMulti
      closeMenuOnSelect={false}
    />
  </div>
</div>

<div className="submit-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',margin:'3px',paddingRight:'10px' }}>
  {/* Search Input at the Left End */}
  <input
    className="search-input"
    type="text"
    placeholder="Search..."
    value={searchText}
    onChange={onFilterTextChange}
    style={{
      width: '30%',
      backgroundColor: 'white',
      marginRight: '8px',
      marginTop: '0',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ced4da',
    }}
  />





  {/* Submit Button at the Right End */}

  <button
    type="submit"
    className="submit-btn"
    onClick={handleSubmit}
  >
    Submit
  </button>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
    {(!columnDefs.length || !rowData.length) ? (
      <div>Loading or no data available</div>
    ) : (
      <div
        className="ag-theme-alpine"
        style={{ height: '430px', width: '65%' }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          quickFilterText={searchText}
          pagination={true} // Enable pagination
          paginationPageSize={9} // Set the number of rows per page
          filter={true} // Enable filtering on the grid level

        />
      </div>
    )}
        </div>


    </div>
  );
}

export default DepartmentCreation;
